import IPage from "../../../interfaces/page"
import DashboardComponent from "../../Components/Dashboard/Dashboard.component"
import MainLayout from "../../layouts/Main/Main.layout"


const DashboardPage: React.FC<IPage> = () => {
    return <MainLayout component={DashboardComponent}></MainLayout>
}

export default DashboardPage